import styles from "./styles.module.css";
import { useTranslations } from "next-intl";
import { ButtonProps } from "types/Button.type";

export default function Button({
  translation,
  text,
  style,
  onClickEvent,
}: ButtonProps) {
  const t = useTranslations(translation);

  return (
    <div className={`${styles.container} ${style || ""} `}>
      <button className={styles.button} onClick={onClickEvent}>
        {t(text)}
      </button>
    </div>
  );
}
